export default __webpack_public_path__ + "static/media/card-american-express.af1724ad.svg";